var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"homePage"},[_c('i',{staticClass:"fa fa-spinner fa-spin fa-2x loadData"}),_c('BaseNotification',{ref:"notificationRef"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }